var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCheckSolid = function SvgCheckSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 18 18",
    fill: "none"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.667 9a8.333 8.333 0 1016.666 0A8.333 8.333 0 00.667 9zm13.045-3.13a.833.833 0 00-1.175.085l-4.98 5.756-2.134-2.134a.833.833 0 00-1.179 1.179l2.767 2.767a.833.833 0 001.22-.044l5.566-6.434a.833.833 0 00-.085-1.175z",
    fill: "#fff"
  })));
};
export default SvgCheckSolid;